const schema = () => ({
  type: "object",
  required: ["lastname", "firstname", "cellphone"],
  properties: {
    firstname: {
      type: "string",
      title: "نام بیمار",
    },
    lastname: {
      type: "string",
      title: "نام خانوادگی",
    },
    cellphone: {
      type: "string",
      title: "شماره همراه",
      minLength: 9,
    },
    national_code: {
      type: "string",
      title: "کد ملی",
      minLength: 10,
      maxLength: 10,
    },
    birth_date: {
      type: "string",
      title: "تاریخ تولد",
    },
    skin_color: {
      type: "string",
      title: "رنگ پوست",
      oneOf: [
        { const: "lightSkin", title: "روشن" },
        { const: "mediumSkin", title: "گندمی" },
        { const: "darkSkin", title: "سبزه" },
        { const: "veryDarkSkin", title: "تیره" },
      ],
    },
    insurance_type: {
      type: "string",
      title: "نوع بیمه",
      oneOf: [
        { const: "tamin", title: "تامین اجتماعی" },
        { const: "salamat", title: "سلامت" },
      ],
    },
    financial_situation: {
      type: "string",
      title: "وضعیت مالی",
      oneOf: [
        { const: "low", title: "ضعیف" },
        { const: "middle", title: "متوسط" },
        { const: "top", title: "خوب" },
      ],
    },
    gender: {
      type: "number",
      title: "جنسیت",
      oneOf: [
        { const: 1, title: "مرد" },
        { const: 0, title: "زن" },
      ],
    },
  },
});

export default schema;
